export default {
  "menu.home": "首页",
  "menu.admin": "数据中台",
  "menu.projects": "项目",
  "menu.tasks": "任务",
  "menu.meetings": "会议",
  "menu.meetings.new": "新建会议",
  "menu.meetings.detail": "会议详情",
  "menu.meetings.edit": "编辑会议",
  "menu.topics": "话题",
  "menu.topics.new": "新建话题",
  "menu.topics.detail": "话题详情",
  "menu.topics.edit": "编辑话题",
  "menu.companies": "客户",
  "menu.companies.new": "新建客户",
  "menu.companies.edit": "编辑客户",
  "menu.companies.contract_new": "新建合同",
  "menu.companies.contract_edit": "编辑合同",
  "menu.companies.client_new": "新建客户Seat",
  "menu.companies.client_edit": "编辑客户Seat",
  "menu.candidates": "专家",
  "menu.candidates.new": "新建专家",
  "menu.candidates.edit": "编辑专家",
  "menu.candidates.payment_infos": "支付信息",
  "menu.candidates.payment_new": "新建支付信息",
  "menu.candidates.payment_edit": "编辑支付信息",
  "menu.galaxy": "Galaxy",
  "menu.client_seat": "客户Seat",
  "menu.client_seat.new": "新建客户Seat",
  "menu.client_seat.edit": "编辑客户Seat",
  "menu.finance": "财务",
  "menu.finance.finance_payment": "专家款支付",
  "menu.finance.finance_collection": "客户收入",
  "menu.finance.finance_invoices": "客户账单",
  "menu.finance.finance_customer_payments": "客户回款",
  "menu.finance.finance_uncharged": "账期",
  "menu.finance.finance_incentives": "销售激励",
  "menu.users": "人员",
  "menu.users.new": "新建用户账号",
  "menu.users.edit": "编辑用户账号",
  "menu.users.reset_password": "重置密码",
  "menu.users.edit_my_password": "编辑密码",
  "menu.users.edit_my_account": "编辑我的账号",
  "menu.settings": "设置",
  "menu.settings.card_templates": "卡片模板",
  "menu.settings.card_templates_new": "新建卡片模板",
  "menu.settings.card_templates_edit": "编辑卡片模板",
  "menu.settings.location_data": "行政区划数据",
  "menu.settings.banks": "银行数据",
  "menu.settings.banks_new": "新建银行数据",
  "menu.settings.banks_edit": "编辑银行数据",
  "menu.settings.payment_companies": "支付主体",
  "menu.settings.payment_companies_new": "新建支付主体",
  "menu.settings.payment_companies_edit": "编辑支付主体",
  "menu.settings.expert_blacklist": "专家黑名单",
  "menu.settings.translation_vendors": "翻译供应商",
  "menu.settings.translation_vendors_new": "新建翻译供应商",
  "menu.settings.translation_vendors_edit": "编辑翻译供应商",
  "menu.settings.roles": "角色管理",
  "menu.settings.permissions": "权限管理",
  "menu.settings.applications": "应用管理",
  "menu.settings.meeting_recordings": "AI 入会安排",
  "menu.settings.industry": "行业数据",
  "menu.settings.industry_new": "新建行业数据",
  "menu.settings.industry_edit": "编辑行业数据",
  "menu.settings.exchange_rates": "汇率管理",
  "menu.settings.account": "我的账号",
  "menu.settings.project_code_areas": "项目编码归属地",
  "menu.settings.project_code_areas_new": "新建项目编码归属地",
  "menu.settings.project_code_areas_edit": "编辑项目编码归属地",
  "menu.projects.add_clients": "添加客户联系人",
  "menu.projects.add_project_task": "添加项目任务",
  "menu.projects.ongoing_project_tasks": "进展中的任务",
  "menu.projects.failed_project_tasks": "未成功的任务",
  "menu.projects.billing_projects": "出账中的任务",
  "menu.project_tasks": "项目任务",
  "menu.project_tasks.detail": "任务详情",
  "menu.project_tasks.edit": "编辑任务",
  "menu.notices": "公告",
  "menu.notices.new": "添加公告",
  "menu.notices.edit": "编辑公告",
  "menu.ranking": "本月业绩排名",
  "menu.callRanking": "客户用量分析",
  "menu.admin.activities": "用户操作细查",
  "menu.admin.expert_recruitment_candidates": "新专家统计",
  "menu.account.center": "个人中心",
  "menu.account.trigger": "触发报错",
  "menu.account.logout": "退出登录"
};
